export default __webpack_public_path__ + "static/media/pexels-andrea-piacquadio-3762940.f07c6fab.jpg";